/** 发起端演示的文档类型 */
export const DocType = {
  /** 动态版 */
  H5: 'h5',
  /** 极速版 */
  JPG: 'jpg'
};

export const ContainerType = {
  /** 白板 */
  BOARD: 'board',
  /** 文档 */
  DOCUMENT: 'document'
};

/** Dom元素前缀 */
export const ContainerNamePrefix = {
  /** Canvas容器 */
  CanvasContainer: 'vh-canvas-container',
  /** canvas 层前缀 */
  Canvas: 'vh-canvas',
  /** iframe 前缀 */
  Iframe: 'vh-iframe',
  /** 静态图片前缀 */
  Image: 'vh-image',
  Drag: 'vh-drag-area'
};

/** 操作文档的命令枚举 */
export const OperateDocumentEnum = {
  /** 设置文档 */
  SetDoc: 'setDoc',
  /** 下一页 */
  NextPage: 'nextPage',
  /** 上一页 */
  PreviousPage: 'prevPage',
  /** 跳转到某一页 */
  GotoPage: 'gotoPage',
  /** 下一步 */
  NextStep: 'nextStep',
  /** 上一步 */
  PreviousStep: 'prevStep',
  /** 跳到某一步 */
  GotoStep: 'gotoStep',
  /** 移除文档 */
  RemoveDocument: 'removeDoc',
  /** 缩放文档 */
  Scale: 'scale',
  /** 是否允许翻页 */
  Pageable: 'pageable',
  /** 播放 */
  Play: 'play',
  /** 暂停 */
  Pause: 'pause'
};

/** 操作画板的命令枚举 */
export const OperateBoardEnum = {
  /** 设置图形id */
  SetGraphic: 'setGraphic',
  /** 设置功能工具id */
  SetTool: 'setTool',
  /** 设置背景颜色，支持RGB | RGBA */
  SetBackgroundColor: 'setBackgroundColor',
  /** 取消舞台所有选中 */
  DiscardActiveObject: 'discardActiveObject',
  /** 清空舞台 */
  Clear: 'clear',
  /** 清空缓存 */
  ClearCache: 'clearCache',
  /** 对当前选中的图形进行属性设置 */
  SetOption: 'setOption',
  /** 设置画板是否可编辑 */
  Editable: 'editable',
  /** 设置画板当前页码 */
  SetCurrentId: 'setCurrentId',
  /** 触发画板自定义事件 */
  Trigger: 'trigger',
  /** 设置所有数据 */
  AllData: 'allData',
  /** 设置画板是否主动缓存数据 */
  Cacheable: 'cacheable',
  /** 设置画布大小 */
  SetSize: 'setSize',
  /** 设置画布大小与远端相同 */
  FitToOrigin: 'fitToOrigin',
  /** 设置画布大小根据画笔数据 */
  SetSizeByDraw: 'setSizeByDraw',
  /** 设置画布大小，并不进行缩放 */
  SetCanvasSize: 'setCanvasSize',
  /** 缩放画布 */
  Scale: 'scale',
  /** 设置选中样纸 */
  SetControlStyle: 'setControlStyle',
  /** 设置水印 */
  SetWatermark: 'SetWatermark',
  ClearWatermark: 'ClearWatermark',
  /** 保存清空 UndoManager数据 */
  SaveData: 'SaveData',
  ClearData: 'ClearData'
};

export const ObjectKV = {};

export const EventTypes = {
  Container: 'container_events',
  Doc: 'doc_events',
  Doodle: 'doodle_events',
  Remote: 'remote_message',
  Vod: 'vod_event',
  Clear: 'clearDoodle'
};

// 文档后端处理类型
export const SENDTYPE = {
  // 自然入库
  NORMAL: 0,
  // 补发重新入库
  RESEND: 1,
  // 补充状态消息
  STATE: 2
};

/** 缩放列表 */
export const ZOOM_FACTORS = [0.25, 0.33, 0.5, 0.66, 1, 1.2, 1.4, 1.6, 1.8, 2, 3, 4];

// 默认水印配置
export const DEFAULT_WATERMARK_OPTION = {
  opacity: 0.5,
  angle: 15,
  fontSize: 12,
  color: '#000000'
};
